import { Box } from '@styles/flexBox';
import styled, { css } from 'styled-components';

export const StatisticMenuHiddenBox = styled(Box)`
  position: absolute;
  top: 5px;
  right: 0;
  border-radius: 20px;
  border: 1px solid var(--border-color, #e5e7eb);

  [data-theme='dark'] & {
    border-color: var(--border-color);
  }

  ${(props) =>
    props.modalAnalytics &&
    css`
      position: static;
      display: flex;
      justify-content: flex-end;

      @media (max-width: 568px) {
        position: relative;
        top: 0;
        justify-content: flex-end;
        width: 100%;
        z-index: 15;
      }
    `}

  ${(props) =>
    props.isAudience &&
    css`
      justify-content: flex-start;
      position: relative;
      top: 38px;
    `}

  ${(props) =>
    props.isProducts &&
    css`
      min-width: 150px;
      min-height: 42px;
      top: 0;
      @media (max-width: 480px) {
        width: 100%;
      }
    `}
`;

export const StatisticMenuDots = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 8px 8px 15px;
  cursor: pointer;

  //outline: 1px dashed deeppink;

  ${(props) =>
    props.modalAnalytics &&
    css`
      position: relative;
      font-size: 14px;
      color: var(--secondary-gray);
      //width: 130px;
      z-index: 1;

      @media (max-width: 568px) {
        width: auto;
        z-index: 15;
      }
    `}

  ${(props) =>
    props.isAudience &&
    css`
      justify-content: space-between;
      width: fit-content;
      background: var(--secondary-background);
      border-radius: 8px;
    `}

  ${(props) =>
    props.isProducts &&
    css`
      min-width: 150px;
      min-height: 42px;
      line-height: 2;
      background: transparent;
      padding: 8px 12px 8px 12px;
      border-radius: 8px;
      box-shadow:
        0 0 0 1px rgba(204, 204, 204, 0),
        0px 0px 0px 1px rgba(0, 0, 0, 0.04),
        0px 1px 4px 0px rgba(0, 0, 0, 0.12);

      &:hover {
        background-color: var(--subtle-background);
      }
    `}

  ${(props) =>
    props.responses &&
    css`
      min-height: 32px;
      background: transparent;
      padding: 8px 12px 8px 12px;
      border-radius: 8px;
      box-shadow:
        0 0 0 1px rgba(204, 204, 204, 0),
        0px 0px 0px 1px rgba(0, 0, 0, 0.04),
        0px 1px 4px 0px rgba(0, 0, 0, 0.12);

      &:hover {
        background-color: var(--subtle-background);
      }
    `}
`;

export const StatisticMenuSettings = styled(Box)`
  display: none;

  position: absolute;
  top: 21px;
  right: -98px;
  z-index: 111;
  color: var(--main-black);
  background: var(--main-background);
  border: 1px solid #959595;
  border-radius: 8px;

  ${(props) =>
    props.show &&
    css`
      display: block;
    `}

  ${(props) =>
    props.modalAnalytics &&
    css`
      top: 28px;
      right: 12px;
      @media (max-width: 480px) {
        padding-top: 12px;
        padding-bottom: 12px;
      }
    `}

  ${(props) =>
    props.isAudience &&
    css`
      top: 43px;
      right: initial;
      left: 1px;
      width: 175px;
    `}

  ${(props) =>
    props.isProducts &&
    css`
      top: 51px;
      left: 0;
      width: 100%;
      right: initial;
    `}

  ${(props) =>
    props.responses &&
    css`
      top: 38px;
      width: 179px;
    `}

  ${(props) =>
    props.isAudience &&
    css`
      @media (max-width: 480px) {
        top: 110%;
      }
    `}
`;

export const StatisticMenuSettingsList = styled(Box)`
  display: flex;
  min-width: 125px;
  flex-direction: column;
  font-size: 14px;
  color: var(--secondary-gray);
  border-radius: 8px;
`;

export const StatisticMenuSettingsItem = styled(Box)`
  display: flex;
  padding: 7px 12px;
  cursor: pointer;

  &:hover {
    border-radius: 8px;
    background: #f9f9f9;
  }
`;

export const StatisticMenuSettingsTitle = styled(Box)`
  margin-left: 10px;
  @media (max-width: 480px) {
    white-space: nowrap;
  }
`;

export const StatisticSubtitle = styled(Box)`
  display: inline-flex;
  font-size: 18px;
  font-weight: bold;
`;

export const HeaderButtonBox = styled(Box)`
  position: relative;
  z-index: 1001;
  margin-left: 25px;

  ${(props) =>
    props.isAudience &&
    css`
      @media (max-width: 480px) {
        margin-left: 0;
        flex: 1;
        width: 100%;
      }
    `}
`;

export const StatisticTotalTitle = styled(Box)`
  font-size: 28px;
  ${(props) =>
    props.withInput &&
    css`
      display: flex;
      flex-direction: column;
      gap: 8px;
    `}

  ${(props) =>
    props.isRight &&
    css`
      margin-right: auto;
    `}

  ${(props) =>
    props.isAudience &&
    css`
      @media (max-width: 480px) {
        font-size: 16px;
        font-weight: bold;
        margin-top: 12px;
        margin-bottom: 12px;
      }
    `}
`;

export const StatisticBox = styled(Box)`
  margin: 24px 0;
  padding: 0;
  display: flex;
  justify-content: space-between;
  color: var(--secondary-gray);

  @media (max-width: 767px) {
    display: none;
  }

  ${(props) =>
    props.gettingAnalyticsStats &&
    css`
      justify-content: center;
    `}

  ${(props) =>
    props.modalAnalytics &&
    css`
      margin: 12px 0;
      width: 100%;

      @media (max-width: 767px) {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      @media (max-width: 480px) {
        gap: 16px;
      }
    `}

  ${(props) =>
    props.menuItem &&
    css`
      padding: 0 24px;
    `}
`;

export const StatisticItemBox = styled(Box)`
  padding: 24px;
  width: 31.5%;
  cursor: pointer;
  border-radius: 16px;
  border: 1px solid var(--border-color, #e5e7eb);

  @media (max-width: 567px) {
    width: 100%;
  }

  ${(props) =>
    props.shop &&
    css`
      display: flex;
      width: 48%;
    `}

  ${(props) =>
    props.menuItem &&
    css`
      width: 18.5%;
      padding: 15px;
    `}

  ${(props) =>
    props.active &&
    css`
      background: #f1f5ff;
    `}

  ${(props) =>
    props.cursorDefault &&
    css`
      cursor: default;
    `}

  ${(props) =>
    props.wide &&
    css`
      width: 49%;
    `}
`;

export const StatisticItemHeader = styled(Box)`
  display: flex;
  align-items: center;
`;

export const StatisticContentBox = styled(Box)`
  margin-left: 20px;

  ${(props) =>
    props.item &&
    css`
      min-height: 45px;
      margin: 0 0 0 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;
    `}
`;

export const StatisticIconBox = styled(Box)`
  background: #eff6ff;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;

  ${(props) =>
    props.shop &&
    css`
      width: 65px;
      height: 65px;
      background: #f2fcf7;

      svg {
        width: 48px;
      }
    `}

  ${(props) =>
    props.botsIconBox &&
    css`
      width: 35px;
      height: 35px;
    `}
`;

export const StatisticIcon = styled.img`
  width: 24px;

  ${(props) =>
    props.botsIcon &&
    css`
      width: 18px;
    `}
`;

export const StatisticData = styled(Box)`
  margin-top: 4px;
  font-size: 32px;
  font-weight: 700;
  color: var(--main-black);

  ${(props) =>
    props.active &&
    css`
      color: #147cff;
    `}

  ${(props) =>
    props.shop &&
    css`
      margin: 0;
      color: var(--main-black);
      font-weight: bold;
    `}

  ${(props) =>
    props.menuItem &&
    css`
      margin: 0;
      line-height: 1;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const StatisticText = styled(Box)`
  margin-top: 40px;
  font-size: 11px;

  ${(props) =>
    props.menuItem &&
    css`
      margin: 12px 0 0 0;
      font-size: 12px;
      color: var(--secondary-gray);
      line-height: 1.4;
    `}
`;

export const StatisticNumber = styled(Box)`
  font-size: 32px;

  ${(props) =>
    props.center &&
    css`
      font-size: 16px;
      margin: 30% auto;
      width: 100%;
      height: 100%;
      text-align: center;
    `}
`;

export const StatisticTitle = styled(Box)`
  margin-top: 2px;
  font-size: 14px;
  color: var(--secondary-gray);

  ${(props) =>
    props.menuItem &&
    css`
      line-height: 1;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const AdditionalAction = styled(Box)`
  display: none;
  margin-bottom: -10px;
  color: var(--secondary-gray);
  text-align: center;

  ${(props) =>
    props.isHideOnlyMobile &&
    css`
      @media (max-width: 767px) {
        display: block;
      }
    `}

  ${(props) =>
    !props.isHideOnlyMobile &&
    css`
      display: block;
    `}

  ${(props) =>
    props.textAlign &&
    css`
      text-align: ${props.textAlign};
    `}
`;

export const UserMenuIconBox = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  font-size: 18px;

  svg {
    flex: none;
  }

  ${(props) =>
    props.isAccountMenu &&
    css`
      width: 24px;
      height: 24px;
      margin-right: 0;
      margin-left: -3px;
    `}
`;

export const IconSavingValue = styled.img`
  width: 16px;
  height: 16px;
`;

export const UserMenuTitle = styled(Box)`
  color: var(--secondary-gray);
  margin-left: 10px;
  font-size: 15px;

  @media (max-width: 480px) {
    margin-left: 0;
    white-space: nowrap;
    ${(props) =>
      props.isActive &&
      css`
        color: var(--main-black);
      `}
  }

  ${(props) =>
    props.flex &&
    css`
      display: flex;
      width: 80%;
    `}
  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
  ${(props) =>
    props.isAccountMenu &&
    css`
      font-size: 14px;
      color: var(--secondary-gray);

      &:hover {
        //color: #a9a9a9;
      }
    `}
`;

export const AdditionalBox = styled(Box)`
  display: flex;
  flex-direction: column;

  ${(props) =>
    props.hide &&
    css`
      @media (max-width: 767px) {
        display: none;
      }
    `}
`;

export const AdditionalBoxHide = styled(Box)`
  ${(props) =>
    props.isHideOnlyMobile &&
    css`
      @media (max-width: 767px) {
        display: none;
      }
    `}

  ${(props) =>
    !props.isHideOnlyMobile &&
    css`
      display: none;
    `}

  ${(props) =>
    props.editBox &&
    css`
      height: 85px;
    `}

  ${(props) =>
    props.isShowing &&
    css`
      display: block;
    `}

  ${(props) =>
    props.heading &&
    css`
      position: relative;
      margin-top: -5px;
      padding: 5px 25px 0 25px;
      box-shadow: 1px 2px 10px rgb(0 0 0 / 8%);
      border-radius: 8px;

      &:before {
        content: '';
        position: absolute;
        top: -10px;
        left: 0;
        width: 100%;
        height: 24px;
        background: var(--main-background);
      }
    `}
`;

export const AdditionalTitle = styled.span`
  padding: 0 10px;
  display: inline-flex;
  cursor: pointer;

  ${(props) =>
    props.bottom &&
    css`
      margin: 15px 0;
      text-align: center;
      display: flex;
      justify-content: center;
    `}

  ${(props) =>
    props.left &&
    css`
      margin: 30px 0 10px 0;
      text-align: left;
    `}


  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.hide &&
    css`
      display: none;
    `}

  ${(props) =>
    props.sectionHeader &&
    css`
      padding: 15px 15px 15px 25px;
      display: flex;
      justify-content: space-between;
      background: var(--main-background);
      color: var(--secondary-gray);
      box-shadow: 1px 2px 10px rgb(0 0 0 / 8%);
      border-radius: 8px;
    `}

  ${(props) =>
    props.flex &&
    css`
      display: flex;
      justify-content: space-between;
      padding-left: 25px;
      padding-right: 15px;
    `}

  ${(props) =>
    props.button &&
    css`
      background: #f3f3f3;
      color: var(--secondary-gray);
      width: 200px;
      margin-left: auto;
      margin-right: auto;
      padding: 15px;
      border-radius: 6px;

      @media (max-width: 767px) {
        padding: 10px;
        width: 160px;
      }
    `}

  ${(props) =>
    props.properties &&
    css`
      width: 38%;
      min-width: 98px;
      z-index: 1000;
      position: relative;
    `}

  ${(props) =>
    props.tools &&
    css`
      padding: 0;
      display: flex;
      align-items: center;
      font-size: 13px;
      color: var(--secondary-gray);

      span {
        margin-left: 10px;
      }
    `}
`;

export const AdditionalIcon = styled.img`
  width: 30px;
  height: 20px;
  margin-top: 2px;
  padding: 0 10px;

  ${({ margin }) =>
    margin &&
    css`
      margin: ${margin};
    `}

  ${(props) =>
    props.active &&
    css`
      transform: rotate(180deg);
    `}

  ${(props) =>
    props.shopModal &&
    css`
      width: initial;
      height: initial;
      padding: 0;
      margin-top: 3px;
    `}
`;
